import { Block } from "@components/block";
import { Button } from "@components/button";
import { Input } from "@components/input";
import { CustomSelect } from "@components/select";
import { Config, DoubleText, Table } from "@components/table";
import { useBoolState } from "@hooks/use-bool-state";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./appeals.module.scss";
import { AdminAppealModal } from "@components/admin-appeal-modal";
import { useAdminAppeals } from "@features/admin/appeals";
import {
  AdminAppealRequest,
  AdminAppealResponse,
} from "@features/admin/appeals/api";
import { Timer } from "@components/timer";
import { formatUsdt, formatRubles } from "@helpers/format";
import { formatDate, formatTime } from "@helpers/date";
import { usePagination } from "@hooks/use-pagination";
import { useUrlFilters } from "@hooks/useUrlFilters";
import { EllipsisText } from "@components/ellipsis-text";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

const adminAppelConfig: Config<AdminAppealResponse> = [
  {
    label: "ID",
    source: "current_appeal",
    renderComponent: (item) => <EllipsisText text={item.order_uuid} copy />,
  },
  {
    label: "Invid",
    source: "current_appeal",
    renderComponent: (item) => <EllipsisText text={item.order_invid} copy />,
  },
  {
    label: "Статус",
    source: "current_appeal",
    renderComponent: (item) => item.status,
  },
  {
    label: "Дата и время",
    source: "current_appeal",
    renderComponent: (item) => {
      const date = formatDate(new Date(item.created_at));
      const time = formatTime(new Date(item.created_at));

      return <DoubleText text={time} subText={date} />;
    },
  },
  {
    label: "Итоговая сумма",
    source: "order_final_amount",
    renderComponent: (cellData, item) => {
      const usdt = formatUsdt(item.order_final_amount_usdt);
      const rubles = formatRubles(cellData);

      return <DoubleText text={rubles} subText={usdt} />;
    },
  },
  {
    label: "Сумма мерчанта",
    source: "current_appeal",
    renderComponent: (item) => {
      if (item.merchant_amount == null || item.merchant_amount_usdt == null)
        return "";
      const usdt = formatUsdt(item.merchant_amount_usdt);
      const rubles = formatRubles(item.merchant_amount);

      return <DoubleText text={usdt} subText={rubles} />;
    },
  },
  {
    label: "Сумма заявки",
    source: "order_start_amount",
    renderComponent: (cellData, item) => {
      const usdt = formatUsdt(item.order_start_amount_usdt);
      const rubles = formatRubles(cellData);

      return <DoubleText text={rubles} subText={usdt} />;
    },
  },
  {
    label: "Тип заявки",
    source: "order_type",
  },
  {
    label: "Email трейдер",
    source: "trader_email",
    renderComponent: (data) => (
      <div
        style={{
          width: "100px",
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
      >
        {data}
      </div>
    ),
  },
  {
    label: "Email мерч",
    source: "merchant_email",
    renderComponent: (data) => (
      <div
        style={{
          width: "100px",
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
      >
        {data}
      </div>
    ),
  },
  {
    label: "Таймер по спору",
    source: "current_appeal",
    renderComponent: (cellData, item) => {
      const created_at = new Date(cellData.created_at);
      const length = item.previous_appeals?.length;
      const addMount = length == null || length == 0 ? 12 : 6;
      const endDate = created_at.setHours(created_at.getHours() + addMount);
      return length == 3 ||
        item.current_appeal.status == "canceled" ||
        item.current_appeal.status == "approved" ? (
        ""
      ) : (
        <>
          <span>
            {length == 1 || length == null
              ? "Первичный"
              : length == 2
                ? "Вторичный"
                : ""}
          </span>
          <Timer endDate={new Date(endDate)} withIcon={false} />
        </>
      );
    },
  },
];

export const AdminAppealsPage = () => {
  const { control, handleSubmit } = useForm<AdminAppealRequest>();
  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const [currentAppeal, setCurrentAppeal] = useState<AdminAppealResponse>();
  const { state, getAdminAppeals } = useAdminAppeals();
  const { page, limit, setPage, setLimit } = usePagination();
  const { setParams } = useUrlFilters();

  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (lastMessage && lastMessage.type == WebsocketUpdateType.Withdrawal) {
      getAdminAppeals({ page, limit, sort_desc: "true" });
    }
  }, [lastMessage, limit, page]);
  useEffect(() => {
    getAdminAppeals({ page, limit, sort_desc: "true" });
  }, [getAdminAppeals, limit, page]);

  const onSearch = (data: AdminAppealRequest) => {
    setParams(data);
    getAdminAppeals({ ...data, limit: 10, sort_desc: "true" });
    setLimit(10);
  };

  const options = [
    // { text: "Проверка", value: "Проверка" },
    { text: "Отклонен", value: "canceled" },
    { text: "Подтвержден", value: "approved" },
    // { text: "Повторно отклонен", value: "Повторно отклонен" },
    { text: "Ожидание", value: "processing" },
    // { text: "Отклонен нами", value: "Отклонен нами" },
    // { text: "Подтвержден нами", value: "Подтвержден нами" },
  ];
  const onDealClick = (item: AdminAppealResponse) => {
    showModal();
    setCurrentAppeal(item);
  };
  return (
    <Block>
      <form className={styles.filter}>
        <Input
          name="order_uuid"
          control={control}
          placeholder="Id заявки"
          clearable
        ></Input>
        <CustomSelect
          name="status"
          control={control}
          options={options}
          placeholder="Статусы"
          styles={{ width: "200px" }}
          clearable
        ></CustomSelect>
        <Input
          name="email"
          control={control}
          placeholder="email"
          clearable
        ></Input>
        <Button className={styles.btn} onClick={handleSubmit(onSearch)}>
          Search
        </Button>
      </form>
      <Table
        config={adminAppelConfig}
        data={state.appeals}
        onRowClick={onDealClick}
        setPage={setPage}
        setLimit={setLimit}
        page={page}
        limit={limit}
        totalCount={state.total_count}
        loading={state.loading}
      ></Table>
      {currentAppeal && (
        <AdminAppealModal
          isModalOpen={isModalOpen}
          hideModal={hideModal}
          data={currentAppeal}
          uuid={currentAppeal.order_uuid}
        />
      )}
    </Block>
  );
};
